var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5351 5.9856C15.1861 5.9856 18.8371 5.9856 22.4881 5.9856C22.9912 5.9856 22.9912 5.99277 22.9912 6.48779C22.9912 8.91266 22.9912 11.3375 22.9912 13.7696C22.9912 15.3264 21.9131 16.3953 20.3464 16.3953C14.4458 16.3953 8.53814 16.3953 2.63762 16.3953C1.07805 16.3881 0 15.3192 0 13.7624C0 11.3375 0 8.91266 0 6.48061C0 5.99277 0.00718698 5.9856 0.510276 5.9856C4.18282 5.9856 7.86256 5.9856 11.5351 5.9856ZM5.74959 11.7465C5.76396 11.3806 5.78552 11.0219 5.43336 10.7779C5.16025 10.5914 4.19001 10.5914 3.91691 10.7779C3.44257 11.0936 3.44257 12.3419 3.91691 12.6719C4.1972 12.8656 5.15307 12.8656 5.43336 12.6719C5.77115 12.4424 5.76396 12.098 5.74959 11.7465Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4997 4.55062C7.87027 4.55062 4.24803 4.55062 0.618601 4.55062C0.00052077 4.55062 -0.0210402 4.55062 0.00770776 3.91212C0.0292687 3.36688 0.0148947 2.80013 0.165821 2.29076C0.467675 1.25768 1.42354 0.612002 2.50159 0.604828C8.49554 0.604828 14.4967 0.604828 20.4906 0.612002C21.8921 0.612002 22.9845 1.724 22.9917 3.12296C22.9917 3.46732 22.9773 3.81886 22.9989 4.16322C23.0132 4.45736 22.8911 4.56497 22.5964 4.5578C21.6405 4.54345 20.6775 4.55062 19.7216 4.55062C16.9834 4.55062 14.2451 4.55062 11.4997 4.55062Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditIcon);
export default __webpack_public_path__ + "static/media/credit-icon.7cd7d0b83499fc3ec7927b0e7e438229.svg";
export { ForwardRef as ReactComponent };